<iframe #adyenIFrame title="Adyen Payment Container" [src]="iFrameUrl" class="w-full mb-3" allow="payment"></iframe>
